function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Group 12");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M8,0 C3.5888,0 0,3.5888 0,8 C0,12.4112 3.5888,16 8,16 C12.4112,16 16,12.4112 16,8 C16,3.5888 12.4112,0 8,0 M8,14.4 C4.4712,14.4 1.6,11.5288 1.6,8 C1.6,4.4712 4.4712,1.6 8,1.6 C11.5288,1.6 14.4,4.4712 14.4,8 C14.4,11.5288 11.5288,14.4 8,14.4 M11.2,7.2 L8.8,7.2 L8.8,4.8 C8.8,4.3576 8.4424,4 8,4 C7.5576,4 7.2,4.3576 7.2,4.8 L7.2,7.2 L4.8,7.2 C4.3576,7.2 4,7.5576 4,8 C4,8.4424 4.3576,8.8 4.8,8.8 L7.2,8.8 L7.2,11.2 C7.2,11.6424 7.5576,12 8,12 C8.4424,12 8.8,11.6424 8.8,11.2 L8.8,8.8 L11.2,8.8 C11.6424,8.8 12,8.4424 12,8 C12,7.5576 11.6424,7.2 11.2,7.2",
  id: "path-1"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "CoinBarter",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Trades-Copy",
  transform: "translate(-61.000000, -444.000000)"
}, React.createElement("g", {
  id: "Group-12",
  transform: "translate(61.000000, 444.000000)"
}, React.createElement("circle", {
  id: "Icon-BG",
  fill: "#B4E0FA",
  cx: 14,
  cy: 14,
  r: 14
}), React.createElement("circle", {
  id: "Fill",
  fill: "#FFFFFF",
  cx: 14.2,
  cy: 14.2,
  r: 7.2
}), React.createElement("g", {
  id: "Monotone",
  transform: "translate(6.000000, 6.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("use", {
  id: "Icon",
  fill: "#0089D9",
  xlinkHref: "#path-1"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/processin.038cd9b6.svg";
export { SvgComponent as ReactComponent };